import { SpriteId } from './SpriteMap'
import { SxProps, Theme, Typography } from '@mui/material'
import { forwardRef } from 'react'

type SpriteIdProps = React.ComponentProps<'svg'> & {
  spriteId: SpriteId
  rotatingAngle?: number
  rotationTime?: number
  sx?: SxProps<Theme>
}

export const SpriteIcon = forwardRef<HTMLSpanElement, SpriteIdProps>(
  (
    { spriteId, rotatingAngle = 0, rotationTime = 0.3, color, width = 18, height = 18, sx },
    ref
  ): React.ReactElement => {
    const rotationDeg = `rotate(${rotatingAngle}deg)`

    return (
      <Typography component="span" color={color ?? 'currentColor'} sx={sx} width={width} height={height} ref={ref}>
        <svg
          style={{ transform: rotationDeg, transition: `transform ${rotationTime}s` }}
          fill="currentColor"
          width={width}
          height={height}
          viewBox="0 0 32 32"
        >
          <use href={`#sprite-${spriteId}`} />
        </svg>
      </Typography>
    )
  }
)
